import { render } from "./AdminSettings.vue?vue&type=template&id=534fd006&scoped=true&ts=true&lang=pug"
import script from "./AdminSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminSettings.vue?vue&type=script&lang=ts&setup=true"

import "./AdminSettings.vue?vue&type=style&index=0&id=534fd006&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534fd006"]])

export default __exports__